import {BaseBannerHookJs, IBannerJson} from 'OK/banners/bannerNew/hooks/BaseBannerHookJs';

export class BannerHookJs extends BaseBannerHookJs<IBannerJson> {
    constructor(uid: string, element: HTMLElement) {
        super('BanMailRBNew', element);
    }
}

export default BannerHookJs;